import { render, staticRenderFns } from "./AccessControlCard.vue?vue&type=template&id=725f933c&"
import script from "./AccessControlCard.vue?vue&type=script&lang=js&"
export * from "./AccessControlCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports